import { useList } from "@refinedev/core";
import { Link } from "react-router-dom";
import { Plus, Edit } from "lucide-react";
import { PageHeader } from "@/components/forms/PageHeader";
import { ToggleActivo } from "@/components/forms/ToggleActivo";

interface Financiera {
  id: string;
  codigo: string;
  nombre: string;
  fee_porcentaje: number;
  aplica_iva_fee: boolean;
  porc_iva: number;
  aplica_4x1000: boolean;
  porc_4x1000: number;
  dias_desembolso_estimado: number;
  activo: boolean;
}

export function FinancierasPage() {
  const { data, isLoading } = useList<Financiera>({ resource: "financieras" });

  return (
    <div>
      <PageHeader
        title="Financieras"
        subtitle="Aliados de financiación"
        actions={
          <Link to="/admin/financieras/nueva" className="btn-primary inline-flex items-center gap-2">
            <Plus className="size-4" /> Nueva
          </Link>
        }
      />

      {isLoading ? (
        <div className="card p-8 text-center text-fg-muted">Cargando...</div>
      ) : (
        <ul className="space-y-2">
          {data?.data.map((f) => (
            <li key={f.id} className="card p-4">
              <div className="flex items-start gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{f.nombre}</span>
                    <span className="text-xs px-2 py-0.5 bg-bg rounded-pill text-fg-muted">
                      {f.codigo}
                    </span>
                    {!f.activo && <span className="text-xs text-error">Inactiva</span>}
                  </div>
                  <p className="text-sm text-fg-muted mt-1">
                    Fee {f.fee_porcentaje}%
                    {f.aplica_iva_fee && ` + IVA ${f.porc_iva}%`}
                    {f.aplica_4x1000 && ` · 4x1000`}
                    {` · ${f.dias_desembolso_estimado} días`}
                  </p>
                </div>
                <ToggleActivo
                  resource="financieras"
                  id={f.id}
                  activo={f.activo}
                  confirmarTexto={`¿Desactivar financiera "${f.nombre}"? No aparecerá en el wizard de ventas.`}
                />
                <Link
                  to={`/admin/financieras/${f.id}/editar`}
                  className="p-2 rounded-md hover:bg-bg text-fg-secondary"
                  aria-label="Editar"
                >
                  <Edit className="size-4" />
                </Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
